import * as Styles from 'layouts/PrivateLayout.styles'
import TextField from 'components/ui/TextField'
import { EmailOutlined } from '@mui/icons-material'
import { useParams, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import Button from 'components/ui/Button'
import { Link } from 'react-router-dom'
import { useUpdateUserMutation } from 'services/teamMembers'
import { enqueueSnackbar } from 'notistack'
import { useGetUsersQuery } from 'services/teamMembers'
import Spinner from 'components/ui/Spinner'

interface FormErrors {
  [key: string]: string
}

const EditUser = () => {
  const { userEmail = '' } = useParams()
  const navigate = useNavigate()
  const [user, setUser] = useState<any>({})
  const [userName, setUserName] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState<FormErrors>({})
  const [updateUser] = useUpdateUserMutation()

  const {
    data: usersData,
    isLoading,
    isFetching
  } = useGetUsersQuery({ filter_by_email: userEmail })

  useEffect(() => {
    if (typeof usersData === 'object') {
      setUser(usersData?.users[0])
      setUserName(usersData?.users[0].full_name)
    }
  }, [usersData])

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setLoading(true)

    if (userName.length < 3) {
      setErrors({
        name: 'Enter a valid user name.'
      })
      return
    }
    const data = {
      body: {
        email: user?.username,
        name: userName
      }
    }

    try {
      const response = await updateUser(data).unwrap()
      console.log('response', response)
      enqueueSnackbar('User updated successfully', {
        variant: 'success'
      })
      navigate('/admin/settings')
    } catch (error) {
      console.error('Failed to update user:', error)
      setErrors({
        submit: 'Failed to update user. Please try again.'
      })
      enqueueSnackbar('Failed to update user. Please try again.', {
        variant: 'error'
      })

      setLoading(false)
    }
  }

  return (
    <div>
      <Styles.CreateEditPageTitleContainer>
        Edit User
      </Styles.CreateEditPageTitleContainer>
      {isLoading && isFetching ? (
        <Spinner />
      ) : (
        <div>
          <form onSubmit={handleSubmit}>
            <Styles.FormColumns border-type="border">
              <Styles.FormColumnLeft>
                <Styles.FormColumnLeftDescription>
                  <strong>Full name*</strong>
                </Styles.FormColumnLeftDescription>
              </Styles.FormColumnLeft>
              <Styles.FormColumnRight>
                <TextField
                  id="fullName"
                  required
                  cc-width="full"
                  label=""
                  error={!!errors.name}
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  helperText={errors.name}
                ></TextField>
              </Styles.FormColumnRight>
            </Styles.FormColumns>
            <Styles.FormColumns border-type="border">
              <Styles.FormColumnLeft>
                <Styles.FormColumnLeftDescription>
                  <strong>Email*</strong>
                </Styles.FormColumnLeftDescription>
              </Styles.FormColumnLeft>
              <Styles.FormColumnRight>
                <div>
                  <EmailOutlined />
                  <span className="pl-2">{user?.username}</span>
                </div>
              </Styles.FormColumnRight>
            </Styles.FormColumns>
            {errors.submit && (
              <Styles.FormColumns>
                <Styles.FormColumnLeft />
                <Styles.FormColumnRight>
                  <div style={{ color: 'red' }}>{errors.submit}</div>
                </Styles.FormColumnRight>
              </Styles.FormColumns>
            )}
            <Styles.FormColumnsFooter>
              <Styles.FormColumnLeft />
              <Styles.FormColumnRight>
                <Styles.FormColumnsFooterButtons>
                  <Link to={'/admin/settings'}>
                    <Button>Cancel</Button>
                  </Link>
                  <Button
                    id="updateCurrentUser"
                    disabled={userName.length < 3 || loading}
                    type="submit"
                    cc-color="purple"
                    loading={loading}
                  >
                    Save
                  </Button>
                </Styles.FormColumnsFooterButtons>
              </Styles.FormColumnRight>
            </Styles.FormColumnsFooter>
          </form>
        </div>
      )}
    </div>
  )
}

export default EditUser
